import { FileText } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtMoney } from "../../../lib/format";
import { downloadFile } from "../../../lib/xutil";
import { useAuth } from "../../../context/AuthContext";
import { useApi } from "../../customer/hooks";
import { PageHead } from "../../../components/common/Page";

export default function MyPayslips() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const q = useApi("myPayslips", "/payroll/my", undefined, { staleTime: 0 });
  return (
    <div className="max-w-2xl space-y-5" data-testid="my-payslips-page">
      <PageHead title={t("payroll.myTitle")} sub={t("payroll.mySub")} />
      <ul className="divide-y divide-slate-100 rounded-2xl bg-white shadow-sm" data-testid="my-payslips">
        {(q.data || []).map((p) => (
          <li key={p.run_id} className="flex items-center gap-3 px-4 py-3" data-testid={`my-payslip-${p.month}-${p.kind}`}>
            <div className="min-w-0 flex-1"><p className="font-semibold text-navy">{p.month} · {t(`payroll.kinds.${p.kind}`)}</p><p className="text-xs text-slate-500">{t("payroll.col.net")}: {fmtMoney(p.net)} · {t("payroll.col.gross")}: {fmtMoney(p.gross)}</p></div>
            <button type="button" onClick={() => downloadFile(`/payroll/runs/${p.run_id}/payslip/${user.id}.pdf`, { lang }, `payslip-${p.month}.pdf`)} className="flex h-10 items-center gap-1 rounded-full px-3 text-sm font-semibold text-navy hover:bg-slate-100" data-testid={`my-payslip-pdf-${p.month}-${p.kind}`}><FileText className="h-4 w-4 text-rose-600" />PDF</button>
          </li>))}
        {q.data && !q.data.length && <li className="p-6 text-center text-sm text-slate-500">{t("payroll.none")}</li>}
      </ul>
    </div>
  );
}
